import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-order",
  "use": "icon-user-order-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-user-order\"><defs><style>#icon-user-order .a{fill:currentColor;}#icon-user-order .b{fill:none;}</style></defs><g transform=\"translate(-347 -274)\"><path class=\"a\" d=\"M19440,21879.012v-.006H19440v-15.842h.006v-.012h3.48v1h-2.49v13.859H19455v-13.859h-2.562v2.35h-7.961v-1h6.967v-2.5h-6.967v-1h7.961v1.152h3.328v.012h.229v15.842h-.229v.006Zm3.459-3.877v-1H19449v1Zm0-2.779v-1h9.006v1Zm0-2.789v-1h9.006v1Zm.021-3.064v-4.5h1v4.5Z\" transform=\"translate(-19086 -21582)\" /><rect class=\"b\" width=\"30\" height=\"30\" transform=\"translate(347 274)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/user-order.svg
// module id = JoJg
// module chunks = 64